


import { initTerracesGrow } from './transitions/ani-terrace-grow.js';


export function initAniTransitions() {
  
  initTerracesGrow();

}
